import React, { useState } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { CATEGORY,JOB_ROLE,DATE_NEWEST_TO_OLDEST,DATE_OLDEST_TO_NEWEST,
    ASCENDING_A_Z,DESCENDING_Z_A,MOST_TO_LEAST,LEAST_TO_MOST,CUSTOM_ORDER,DATE
   } from "constants/options";
import { useMilestones } from "redux/modules/milestone/hooks";
import { groupTypes } from "utils/constant";
import PopInfo from "components/info-popup/pop-info";



const CustomDropdown = ({
    openCustomOrder=()=>{},
    title="Organize By",
    t,
    profileType='personal', // Default to 'personal' if not provided
    notSidebar = false
}) => { 

    const groupOptions = [ // add value for translation purposes
      {
        label: t('Category'),
        value: CATEGORY,
        options: [
          { value: ASCENDING_A_Z, label: t('Ascending(a-z)'), group:CATEGORY },
          { value: DESCENDING_Z_A, label: t('Descending(z-a)'), group:CATEGORY  },
          { value: MOST_TO_LEAST, label: t('Most to Least'), group:CATEGORY  },
          { value: LEAST_TO_MOST, label: t('Least to Most'), group:CATEGORY  },
          { value: CUSTOM_ORDER, label: t('Custom Order'), group:CATEGORY  },
        ],
      },
      {
        label: t('Job/Role'),
        value: JOB_ROLE,
        options: [
          { value: ASCENDING_A_Z, label: t('Ascending(a-z)'), group:JOB_ROLE  },
          { value: DESCENDING_Z_A, label: t('Descending(z-a)'), group:JOB_ROLE  },
          { value: MOST_TO_LEAST, label: t('Most to Least'), group:JOB_ROLE  },
          { value: LEAST_TO_MOST, label: t('Least to Most'), group:JOB_ROLE  },
          { value: CUSTOM_ORDER, label: t('Custom Order'), group:JOB_ROLE  },
        ],
      },
      {
          label: t('Date'),
          value: DATE,
          options: [
            { value: DATE_NEWEST_TO_OLDEST, label: t('Newest to oldest'), group:DATE  },
            { value: DATE_OLDEST_TO_NEWEST, label: t('Oldest to newest'), group:DATE  },
          ],
        },
    ];

    const {organizeBy,sort} = useMilestones()
    const [openedGroup, setOpenedGroup] = useState(null);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [selectedOption, setSelectedOption] = useState(`${(organizeBy || sort) ? `${organizeBy} - ${sort}` : '' }`);
    
    React.useEffect(()=>{
        setSelectedOption(`${(organizeBy || sort) ? `${t(organizeBy)} - ${t(sort)}` : '' }`)
    },[organizeBy,sort,t])

    // Filter out JOB_ROLE if profileType is business, group, or team
    const filteredGroupOptions = groupOptions.filter(group => {
      if (groupTypes.includes(profileType) && group.label === JOB_ROLE) {
          return false;
      }
      return true;
    });
    
    const filteredGroups = filteredGroupOptions
      .map((group) => ({
        ...group,
        options: group.options.filter((option) =>
          option.value.toLowerCase().includes(filterText.toLowerCase())
        ),
      }))
      .filter(
        (group) =>
          group.value.toLowerCase().includes(filterText.toLowerCase()) ||
          group.options.length > 0
      );
  
    const handleLabelClick = (value) => {
      if (openedGroup === value) {
        setOpenedGroup(null); 
      } else {
        setOpenedGroup(value);
      }
    };
    
  
    const handleDropdownLeave = () => {
      setOpenedGroup(null);
    };

    const handleChange = (selectedOption) => {
        const groupLabel = groupOptions.find((group) =>
          group.options.some((option) => option.group === selectedOption.group)
        )?.value;
        console.log(selectedOption)
        setSelectedOption(`${t(selectedOption.group)} - ${t(selectedOption.label)}`);
        openCustomOrder(groupLabel,selectedOption);
        setOpenedGroup(null); 
        setIsDropdownVisible(false)
      };
  
    return (
      <div
        className={`relative w-full h-13 3md:h-17 bg-white rounded-md pl-4 pr-2 pt-1 3md:pt-3 border border-gray cursor-pointer mt-[6px] 3md:mt-0 2sm:min-h-[4.25rem] 2sm:mt-0 2sm:pt-3 flex flex-col ${notSidebar && '3md:w-64'}`}
      
      >
        <div className="flex flex-col flex-1 justify-between">
            <label className="block font-semibold text-gray-400 text-2xs 3md:text-md inline-flex gap-1">
            {title}
            <div className="text-black font-normal text-normal">
              <PopInfo small={true} type={"organise_by"} className="relative" topCss="-8.5rem" containerClass="relative top-0"/>
            </div>
            </label>
    
            <div onClick={() => setIsDropdownVisible(true)}
              className={`relative flex-1 flex flex-row items-center ${selectedOption && 'place-holder'}`}>
            <input 
                type="text"
                placeholder={selectedOption || t('select')}
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                className="w-full px-4 border-none rounded-none focus:outline-none pr-10 
                customSelect cursor-pointer text-base scale-75 origin-left md:scale-none 3md:text-xl"
            />
            <div
                className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none"
            >
                <svg
                className="w-4 h-4 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                />
                </svg>
            </div>
            </div>
        </div>
  
        {/* Main Dropdown */}
        {isDropdownVisible && (
            <div
            className="absolute left-0 w-full mt-4 bg-white border border-gray rounded-b-md shadow-md z-10"
            onMouseLeave={handleDropdownLeave} 
          >
            {filteredGroups.length > 0 ? (
              filteredGroups.map((group, index) => (
                <div key={index} className="relative">
                  <div
                    className={`px-4 py-2 cursor-pointer hover:bg-gray flex justify-between w-full items-center text-xs 3md:text-md ${
                      openedGroup === group.label ? "bg-gray-100" : ""
                    }`}
                    onClick={() => handleLabelClick(group.value)}
                    onMouseEnter={() => setOpenedGroup(group.value)}
                  >
                    {group.label}
                    <MdOutlineKeyboardArrowRight/>
                  </div>
  
                  {openedGroup === group.value && (
                    <div className="px-4">
                        <div className={`absolute right-[100%] 3md:left-[100%] top-0 w-48 bg-white border border-gray rounded-md shadow-lg z-20 ml-[1.5px] w-36 3md:w-52`}>
                        {group.options.map((option) => (
                            <div
                            key={option.value}
                            className="px-4 py-2 text-xs 3md:text-md cursor-pointer hover:bg-gray"
                            onClick={() => handleChange(option)}
                            >
                            {option.label}
                            </div>
                        ))}
                        </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-500 text-xs 3md:text-md">No results found</div>
            )}
          </div>
        )}
  
        {/* Close dropdown on outside click */}
        {isDropdownVisible && (
          <div
            className="fixed inset-0 z-0"
            onClick={() => {
              setIsDropdownVisible(false);
              setOpenedGroup(null);
            }}
          ></div>
        )}
      </div>
    );
  };

export default CustomDropdown;
